import './utils/numeralLocale';
import './index.css';
import { TranslatorProvider } from 'react-translate';
import { translationsPT } from './translate';

// redux
import React from 'react';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware, compose } from 'redux';
import rootReducers from '@redux/rootReducers';
import createSagaMiddleware from 'redux-saga'; // SAGA
import rootSagas from '@redux/rootSagas';

// Styles
import { ThemeProvider } from 'styled-components';
import { DefaultTheme } from './styles';

// Router
import { HashRouter } from 'react-router-dom';
import {
  faCircle as fadCircle,
  faArrowLeft as fadArrowLeft,
  faStoreAlt as fadStoreAlt,
  faEllipsisVAlt as fadEllipsisVAlt,
} from '@fortawesome/pro-duotone-svg-icons';
// Icons
import { library } from '@fortawesome/fontawesome-svg-core';
// regular
import {
  faChevronDown as farChevronDown,
  faArrowRight as farArrowRight,
  faChevronLeft,
  faEllipsisV as farEllipsisV,
  faCheckDouble as farCheckDouble,
  faCoffee,
  faCircleNotch as farCircleNotch,
  faChartBar,
  faUser,
  faQuestionCircle as farQuestionCircle,
  faBriefcase,
  faSitemap,
  faGlobeAmericas,
  faPrint as farPrint,
  faVideo as farVideo,
  faPen,
  faSignOutAlt,
  faCheck as farCheck,
  faTrophy,
  faWallet,
  faAngleDown,
  faAngleUp,
  faCalendarAlt,
  faLightbulbExclamation,
  faPlus as farPlus,
  faMinus as farMinus,
  faEmptySet,
  faCogs,
  faMedal,
  faAd,
  faFilter as farFilter,
  faEraser,
  faKey,
  faUsers,
  faUserEdit,
  faUserPlus,
  faSyncAlt,
  faExclamation,
  faUserCrown,
  faUserShield,
  faShieldAlt,
  faHandHoldingUsd,
  faBuilding,
  faBan,
  faExchangeAlt,
  faEnvelope,
  faEnvelopeOpen,
  faStore,
  faGlobe as farGlobe,
  faChild as farChild,
  faGlasses as farGlasses,
  faTrash,
  faSortAmountUp,
  faSortAmountDown,
  faHistory,
  faPiggyBank,
  faAbacus,
  faImages,
  faFunnelDollar,
  faFlag as farFlag,
  faBullhorn,
  faLayerGroup as farLayergroup,
  faMapMarkerAlt,
  faArrowUp,
  faStop,
  faPlay as farPlay,
  faEye as farEye,
  faDonate as farDonate,
  faBookmark as farBookmark,
  faWifiSlash,
  faChevronUp as farChevronUp,
} from '@fortawesome/pro-regular-svg-icons';
// solid
import {
  faStar as fasStar,
  faEdit as fasEdit,
  faDesktop,
  faArrowAltUp,
  faArrowAltDown,
  faCheckCircle as fasCheckCircle,
  faExclamationCircle,
  faTimesCircle,
  faCircle as fasCircle,
  faBadge,
  faMousePointer as fasMousePointer,
  faThumbsUp as fasThumbsUp,
  faVideo as fasVideo,
  faPrint as fasPrint,
  faPeopleCarry,
  faBookmark,
  faSignalAlt1,
  faEllipsisH,
  faCamera as fasCamera,
  faPlay as fasPlay,
  faBackward,
  faLayerGroup,
} from '@fortawesome/pro-solid-svg-icons';
// light
import {
  faMoneyCheckEditAlt,
  faMoneyBillAlt,
  faStar as falStar,
  faMousePointer as falMousePointer,
  faThList as falFaThList,
  faUpload as falUpload,
  faUserFriends as falUserFriends,
  faSearchPlus as falSearchPlus,
  faQuestionCircle as falQuestionCircle,
  faArrowAltUp as falArrowAltUp,
  faCircleNotch as falCircleNotch,
  faListUl,
  faUserTie,
  faUsersCog,
  faAddressCard,
  faUserCircle,
  faUserCheck,
  faUserLock,
  faUserMinus,
  faUserClock,
  faClock,
  faDice,
  faRobot,
  faUserCog,
  faLifeRing,
  faIndustryAlt,
  faSearch,
  faBell,
  faQuestion,
  faBars,
  faTimes,
  faChevronDoubleUp,
  faChevronDoubleDown,
  faPencilAlt,
  faTrashAlt,
  faThumbsUp as falThumbsUp,
  faThumbsDown,
  faUsdCircle,
  faInboxOut,
  faCalendarCheck,
  faReceipt,
  faAngleRight,
  faUserTimes,
  faUserSlash,
  faLink,
  faExternalLinkAlt,
  faClone,
  faAngleDoubleDown,
  faCamera as falCamera,
  faShare,
  faEye as falEye,
  faUserTag,
  faPlayCircle as falPlayCircle,
  faFilmAlt,
  faLayerGroup as falLayergroup,
  faTimes as falTimes,
  faFlag as fasFlag,
  faLocation,
  faLocationCircle,
  faInfoCircle,
  faChevronRight,
  faGlobe as falGlobe,
  faChild as falChild,
  faGlasses as falGlasses,
  faFilter as falFilter,
  faSquare,
  faComment,
  faCheck as falCheck,
  faCommentAlt,
  faDownload,
  faCheckCircle as falCheckCircle,
  faVideo as falVideo,
  faSortAmountUp as falSortAmountUp,
  faSortAmountDown as falSortAmountDown,
  faMinusOctagon as falMinusOctagon,
  faHistory as falHistory,
  faPiggyBank as falPiggyBank,
  faMobileAlt,
  faDesktop as falDesktop,
  faImage,
  faCheckDouble,
  faPaperPlane,
  faExclamationTriangle,
  faShieldCheck,
  faWindowClose,
  faCog,
  faPencil,
  faStopCircle as falStopCircle,
  faMinus as falMinus,
  faPlus as falPlus,
  faChartLine,
  faShareAlt,
  faPrint as falPrint,
  faHeartRate,
  faChevronUp,
  faChevronDown as falChevronDown,
  faLongArrowLeft,
  faIdCard,
  faHandshakeAlt,
  faHeart,

} from '@fortawesome/pro-light-svg-icons';
// brands
import {
  faFacebook,
  faInstagram,
  faFacebookF,
  faSpotify,
  faAmazon,
  faGoogle,
  faTwitter,
  faWindows,
  faApple,
  faAndroid,
  faFacebookSquare,
  faGooglePlusG,
  faYoutube,
  faWhatsapp,
} from '@fortawesome/free-brands-svg-icons';
import { Store } from './components/Store';

// create the saga middleware
const sagaMiddleware = createSagaMiddleware();

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
export const store = createStore(
  rootReducers,
  {},
  composeEnhancers(applyMiddleware(sagaMiddleware))
);

// run the saga
sagaMiddleware.run(rootSagas);

// Register Icons
library.add(
  falChevronDown,
  farChevronDown,
  falPlayCircle,
  faChevronUp,
  falUpload,
  falSearchPlus,
  falFaThList,
  faListUl,
  farArrowRight,
  faChevronLeft,
  farEllipsisV,
  fasEdit,
  farCheckDouble,
  falStopCircle,
  faCoffee,
  falUserFriends,
  farCircleNotch,
  falCircleNotch,
  faChartBar,
  faUser,
  falQuestionCircle,
  farQuestionCircle,
  faBriefcase,
  faSitemap,
  faGlobeAmericas,
  farPrint,
  farVideo,
  falVideo,
  faPen,
  fadCircle,
  fadArrowLeft,
  faLongArrowLeft,
  fadStoreAlt,
  fadEllipsisVAlt,
  faSignOutAlt,
  farCheck,
  faTrophy,
  faWallet,
  faAngleDown,
  faAngleUp,
  faCalendarAlt,
  faChartLine,
  faLightbulbExclamation,
  farPlus,
  farMinus,
  faEmptySet,
  faCogs,
  faMedal,
  faAd,
  farFilter,
  faEraser,
  faKey,
  faUsers,
  faUserEdit,
  faUserPlus,
  faSyncAlt,
  faExclamation,
  faUserCrown,
  faUserShield,
  faShieldAlt,
  faHandHoldingUsd,
  faBuilding,
  faBan,
  faExchangeAlt,
  faEnvelope,
  faEnvelopeOpen,
  faStore,
  farGlobe,
  farChild,
  farGlasses,
  faTrash,
  faSortAmountUp,
  faSortAmountDown,
  faHistory,
  faPiggyBank,
  faAbacus,
  faImages,
  faFunnelDollar,
  farFlag,
  faBullhorn,
  farLayergroup,
  faMapMarkerAlt,
  faArrowUp,
  faStop,
  farPlay,
  fasStar,
  falStar,
  faDesktop,
  falArrowAltUp,
  faArrowAltUp,
  faArrowAltDown,
  fasCheckCircle,
  falCheckCircle,
  faExclamationCircle,
  faExclamationTriangle,
  faTimesCircle,
  fasCircle,
  faBadge,
  fasMousePointer,
  falMousePointer,
  faMoneyBillAlt,
  fasThumbsUp,
  fasVideo,
  fasPrint,
  faPeopleCarry,
  faUserTie,
  faUsersCog,
  faAddressCard,
  faUserCircle,
  faUserCheck,
  faUserLock,
  faUserMinus,
  faUserClock,
  faClock,
  faDice,
  faRobot,
  faUserCog,
  faLifeRing,
  faIndustryAlt,
  faSearch,
  faBell,
  faQuestion,
  faBars,
  faTimes,
  faChevronDoubleUp,
  faChevronDoubleDown,
  faPencilAlt,
  faTrashAlt,
  falThumbsUp,
  faThumbsDown,
  faUsdCircle,
  faInboxOut,
  faCalendarCheck,
  faReceipt,
  faAngleRight,
  faUserTimes,
  faUserSlash,
  faLink,
  faExternalLinkAlt,
  faClone,
  faAngleDoubleDown,
  falCamera,
  faShare,
  falEye,
  farEye,
  farDonate,
  faUserTag,
  faFilmAlt,
  falLayergroup,
  falTimes,
  fasFlag,
  faLocation,
  faLocationCircle,
  faInfoCircle,
  faChevronRight,
  falGlobe,
  falChild,
  falGlasses,
  falFilter,
  faSquare,
  faComment,
  falCheck,
  faCommentAlt,
  faDownload,
  faFacebook,
  faInstagram,
  faFacebookF,
  faSpotify,
  faAmazon,
  faGoogle,
  faTwitter,
  faWindows,
  faApple,
  faAndroid,
  faFacebookSquare,
  faGooglePlusG,
  faYoutube,
  faBookmark,
  falSortAmountUp,
  falSortAmountDown,
  falMinusOctagon,
  falHistory,
  falPiggyBank,
  faMobileAlt,
  falDesktop,
  faSignalAlt1,
  farBookmark,
  faImage,
  faCheckDouble,
  faPaperPlane,
  faShieldCheck,
  faWindowClose,
  faCog,
  faEllipsisH,
  faPencil,
  falMinus,
  falPlus,
  fasCamera,
  fasPlay,
  faWifiSlash,
  faShareAlt,
  falPrint,
  faHeartRate,
  faBackward,
  faWhatsapp,
  faLayerGroup,
  faIdCard,
  faHandshakeAlt,
  faHeart,
  farChevronUp,
  faMoneyCheckEditAlt
);

const Providers = ({ children }) => (
  <ThemeProvider theme={DefaultTheme}>
    <Store>
      <Provider store={store}>
        <HashRouter>
          <TranslatorProvider translations={translationsPT}>{children}</TranslatorProvider>
        </HashRouter>
      </Provider>
    </Store>
  </ThemeProvider>
);

export default Providers;
